module.exports = __webpack_public_path__ + "static/media/FD10.0a9aa81a.png";